import type { IView } from '@barba/core';
import select from '../components/select';
import calendly from '../components/calendly';
import teamVideos from '../components/team-videos';

export default {
    namespace: 'booking-page',

    beforeEnter({ next }) {
        select.init(next.container);
        calendly.init(next.container);
        teamVideos.init(next.container);

        const storedEmail = localStorage.getItem('CALENDLY_EMAIL');
        const storedDate = localStorage.getItem('CALENDLY_DATE');
        const thanksEmailEl = document.querySelector<HTMLElement>('.js-calendly-thanks-email');
        const thanksMonthEl = document.querySelector<HTMLElement>('.js-calendly-thanks-month');
        const thanksDayEl = document.querySelector<HTMLElement>('.js-calendly-thanks-day');
        const thanksWeekDayEl = document.querySelector<HTMLElement>('.js-calendly-thanks-weekday');

        if (thanksEmailEl && storedEmail) {
            thanksEmailEl.dataset.hover = storedEmail;
            const linkText = thanksEmailEl.querySelector('.link__text');

            if (linkText) {
                linkText.textContent = storedEmail;
            }
        }

        if (storedDate) {
            const date = new Date(storedDate);
            const months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

            if (thanksMonthEl) {
                thanksMonthEl.textContent = months[date.getMonth()];
            }

            if (thanksDayEl) {
                thanksDayEl.textContent = `${date.getDate()}`;
            }

            if (thanksWeekDayEl) {
                thanksWeekDayEl.textContent = daysOfWeek[date.getDay()];
            }
        }
    },

    afterLeave({ current }) {
        select.destroy(current.container);
        teamVideos.destroy();
        calendly.destroy();
    },
} as IView;
